(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const config = window.NewenHolding || { routes: {}, settings: {}, strings: {} };
  let lastFocused = null;
  const escapeHTML = (value) => String(value).replace(/[&<>'\"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '\"': '&quot;' })[character]);
  const normalizedRoot = `${String(config.routes.root || '/').replace(/\/+$/, '')}/`;
  const productPathPrefix = `${normalizedRoot}products/`;
  const isProductUrl = (value) => {
    try {
      const url = value instanceof URL ? value : new URL(value, window.location.href);
      return url.origin === window.location.origin && url.pathname.startsWith(productPathPrefix);
    } catch (_) {
      return false;
    }
  };

  const toast = (message) => {
    const region = $('[data-toast-region]');
    if (!region || !message) return;
    const item = document.createElement('div');
    item.className = 'toast';
    item.textContent = message;
    region.append(item);
    window.setTimeout(() => item.remove(), 3600);
  };

  const updateCartCount = (count) => {
    $$('[data-cart-count]').forEach((bubble) => {
      bubble.textContent = count;
      bubble.hidden = Number(count) < 1;
    });
  };

  const focusables = (container) => $$('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])', container).filter((el) => !el.hidden);

  const openDrawer = (id) => {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    const items = focusables(drawer);
    if (items.length) items[0].focus();
  };

  const closeDrawer = (drawer) => {
    if (typeof drawer === 'string') drawer = document.getElementById(drawer);
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('drawer-open');
    if (lastFocused) lastFocused.focus();
  };

  const replaceCartDrawer = (html) => {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const incoming = $('.cart-drawer__inner', parsed);
    const current = $('.cart-drawer__inner');
    if (incoming && current) current.replaceWith(incoming);
  };

  const refreshCart = async (open = false) => {
    try {
      const [cartResponse, sectionResponse] = await Promise.all([
        fetch(`${config.routes.cart}.js`, { headers: { Accept: 'application/json' } }),
        fetch(`${config.routes.cart}?section_id=cart-drawer`)
      ]);
      if (!cartResponse.ok || !sectionResponse.ok) throw new Error('Cart refresh failed');
      const cart = await cartResponse.json();
      replaceCartDrawer(await sectionResponse.text());
      updateCartCount(cart.item_count);
      if (open) openDrawer('CartDrawer');
      return cart;
    } catch (error) {
      toast(config.strings.cartError);
      return null;
    }
  };

  const submitProduct = async (form) => {
    const button = $('[type="submit"]', form);
    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
    }
    try {
      const response = await fetch(`${config.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || config.strings.addError);
      toast(config.strings.added);
      await refreshCart(true);
      form.dispatchEvent(new CustomEvent('newen:product-added', { bubbles: true, detail: data }));
    } catch (error) {
      toast(error.message || config.strings.addError);
      const errors = $('[data-product-errors]', form);
      if (errors) {
        errors.hidden = false;
        errors.textContent = error.message || config.strings.addError;
      }
    } finally {
      if (button) {
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    }
  };

  const changeCartLine = async (line, quantity, trigger) => {
    if (trigger) trigger.disabled = true;
    try {
      const response = await fetch(`${config.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      if (!response.ok) throw new Error(config.strings.cartError);
      await refreshCart(false);
    } catch (error) {
      toast(error.message || config.strings.cartError);
    } finally {
      if (trigger && trigger.isConnected) trigger.disabled = false;
    }
  };

  const wishlistKey = 'newen:wishlist';
  const getWishlist = () => {
    try { return JSON.parse(localStorage.getItem(wishlistKey)) || []; } catch (_) { return []; }
  };
  const syncWishlist = () => {
    const saved = getWishlist();
    $$('[data-wishlist-button]').forEach((button) => {
      const active = saved.includes(button.dataset.productHandle);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? (button.dataset.removeLabel || 'Quitar de favoritos') : (button.dataset.addLabel || 'Guardar en favoritos'));
      const label = $('[data-wishlist-label]', button);
      if (label) label.textContent = active ? (button.dataset.removeLabel || 'Quitar de favoritos') : (button.dataset.addLabel || 'Guardar en favoritos');
    });
  };
  const toggleWishlist = (button) => {
    const handle = button.dataset.productHandle;
    let saved = getWishlist();
    const active = saved.includes(handle);
    saved = active ? saved.filter((item) => item !== handle) : [...saved, handle];
    localStorage.setItem(wishlistKey, JSON.stringify(saved));
    syncWishlist();
    toast(active ? config.strings.wishlistRemoved : config.strings.wishlistAdded);
    document.dispatchEvent(new CustomEvent('newen:wishlist-updated'));
  };

  const initWishlistPage = async () => {
    const container = $('[data-wishlist-products]');
    if (!container) return;
    const empty = $('[data-wishlist-empty]');
    const render = async () => {
      const handles = getWishlist();
      container.innerHTML = '';
      if (empty) empty.hidden = handles.length > 0;
      if (!handles.length) return;
      container.setAttribute('aria-busy', 'true');
      const products = await Promise.all(handles.map(async (handle) => {
        try {
          const response = await fetch(`${productPathPrefix}${encodeURIComponent(handle)}.js`);
          return response.ok ? response.json() : null;
        } catch (_) { return null; }
      }));
      products.filter(Boolean).forEach((product) => {
        const article = document.createElement('article');
        article.className = 'product-card';
        const productUrl = `${productPathPrefix}${encodeURIComponent(product.handle)}`;
        const image = product.featured_image ? `<div class="media media--square"><a href="${productUrl}" data-product-link data-no-transition><img src="${escapeHTML(product.featured_image)}" alt="" loading="lazy" width="600" height="600"></a></div>` : '';
        article.innerHTML = `${image}<div class="product-card__content"><h2 class="product-card__title"><a href="${productUrl}" data-product-link data-no-transition>${escapeHTML(product.title)}</a></h2><button class="button button--secondary button--small" type="button" data-wishlist-button data-product-handle="${escapeHTML(product.handle)}" aria-pressed="true"><span data-wishlist-label>Quitar de favoritos</span></button></div>`;
        container.append(article);
      });
      container.removeAttribute('aria-busy');
      syncWishlist();
    };
    document.addEventListener('newen:wishlist-updated', render);
    await render();
  };

  const initPredictiveSearch = () => {
    $$('[data-predictive-search-input]').forEach((input) => {
      let controller;
      let timeout;
      input.addEventListener('input', () => {
        window.clearTimeout(timeout);
        const term = input.value.trim();
        const target = $('[data-predictive-search-results]', input.closest('form')?.parentElement || document);
        if (!target) return;
        if (term.length < 2) { target.innerHTML = ''; return; }
        timeout = window.setTimeout(async () => {
          if (controller) controller.abort();
          controller = new AbortController();
          target.setAttribute('aria-busy', 'true');
          try {
            const url = `${config.routes.predictiveSearch}?q=${encodeURIComponent(term)}&resources[type]=product,page,article&resources[limit]=6&section_id=predictive-search`;
            const response = await fetch(url, { signal: controller.signal });
            if (!response.ok) throw new Error();
            const html = await response.text();
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            target.innerHTML = $('.predictive-search', parsed)?.innerHTML || '';
          } catch (error) {
            if (error.name !== 'AbortError') target.innerHTML = '';
          } finally { target.removeAttribute('aria-busy'); }
        }, 220);
      });
    });
  };

  const initReveal = () => {
    const items = $$('[data-reveal]');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    items.forEach((item) => observer.observe(item));
  };

  const navigateWithTransition = (url) => {
    if (url) window.location.assign(url);
  };

  const updateHeroHandoffs = () => {
    $$('[data-hero-handoff]').forEach((handoff) => {
      const hero = handoff.previousElementSibling;
      if (!hero?.matches('[data-hero-panel]')) return;
      const heroTop = hero.getBoundingClientRect().top + window.scrollY;
      const distance = Math.max(hero.offsetHeight * .58, 1);
      const progress = Math.max(0, Math.min(1, (window.scrollY - heroTop) / distance));
      handoff.style.setProperty('--handoff-progress', progress.toFixed(3));
    });
  };

  const initHeroHandoffs = () => {
    updateHeroHandoffs();
    if (document.documentElement.dataset.heroHandoffInitialized === 'true') return;
    document.documentElement.dataset.heroHandoffInitialized = 'true';
    let scheduled = false;
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        updateHeroHandoffs();
        scheduled = false;
      });
    };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
  };

  const initSectionWaves = () => {
    const main = document.getElementById('MainContent');
    if (!main) return;
    const sections = [...main.children].filter((element) => element.classList.contains('shopify-section') && element.querySelector('section,article,aside,header'));
    sections.slice(1).forEach((section, index) => {
      const previousSection = sections[index];
      if (previousSection?.querySelector('[data-hero-panel]')) return;
      if (section.querySelector('.faq-preview-section')) return;
      if (section.previousElementSibling?.classList.contains('section-wave')) return;
      const divider = document.createElement('div');
      divider.className = 'section-wave';
      divider.setAttribute('aria-hidden', 'true');
      divider.innerHTML = '<span></span><span></span>';
      section.before(divider);
    });
  };

  const initFaqAccordions = (root = document) => {
    const accordions = root.matches?.('[data-faq-accordion]') ? [root] : $$('[data-faq-accordion]', root);
    accordions.forEach((accordion) => {
      if (accordion.dataset.faqInitialized === 'true') return;
      accordion.dataset.faqInitialized = 'true';
      $$('details', accordion).forEach((item) => item.addEventListener('toggle', () => {
        if (!item.open) return;
        $$('details[open]', accordion).forEach((openItem) => {
          if (openItem !== item) openItem.removeAttribute('open');
        });
      }));
    });
  };

  const initProductCardMotion = (root = document) => {
    if (matchMedia('(hover: none), (prefers-reduced-motion: reduce)').matches) return;
    const cards = root.matches?.('[data-product-card]') ? [root] : $$('[data-product-card]', root);
    cards.forEach((card) => {
      if (card.dataset.motionInitialized === 'true') return;
      card.dataset.motionInitialized = 'true';
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width;
        const y = (event.clientY - rect.top) / rect.height;
        card.style.setProperty('--tilt-x', `${((.5 - y) * 5).toFixed(2)}deg`);
        card.style.setProperty('--tilt-y', `${((x - .5) * 6).toFixed(2)}deg`);
        card.style.setProperty('--shine-x', `${(x * 100).toFixed(1)}%`);
        card.style.setProperty('--shine-y', `${(y * 100).toFixed(1)}%`);
      });
      card.addEventListener('pointerleave', () => {
        card.style.setProperty('--tilt-x', '0deg');
        card.style.setProperty('--tilt-y', '0deg');
      });
    });
  };

  const cleanRut = (value) => String(value || '').replace(/[^0-9kK]/g, '').toUpperCase();
  const formatRut = (value) => {
    const clean = cleanRut(value);
    if (clean.length < 2) return clean;
    const body = clean.slice(0, -1).replace(/^0+/, '') || '0';
    const verifier = clean.slice(-1);
    return `${body.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}-${verifier}`;
  };
  const isValidRut = (value) => {
    const clean = cleanRut(value);
    if (!/^\d{7,8}[0-9K]$/.test(clean)) return false;
    const body = clean.slice(0, -1);
    const verifier = clean.slice(-1);
    let sum = 0;
    let multiplier = 2;
    for (let index = body.length - 1; index >= 0; index -= 1) {
      sum += Number(body[index]) * multiplier;
      multiplier = multiplier === 7 ? 2 : multiplier + 1;
    }
    const result = 11 - (sum % 11);
    const expected = result === 11 ? '0' : result === 10 ? 'K' : String(result);
    return verifier === expected;
  };

  const validateCheckoutRut = (form) => {
    const input = $('[data-rut-input]', form);
    const error = $('[data-rut-error]', form);
    if (!input) return true;
    const valid = isValidRut(input.value);
    input.setCustomValidity(valid ? '' : 'Ingresa un RUT chileno válido.');
    if (error) error.hidden = valid;
    if (!valid) {
      input.focus();
      input.reportValidity();
    } else input.value = formatRut(input.value);
    return valid;
  };

  const syncProductReviewSummary = () => {
    const reviews = $('[data-product-reviews]');
    if (!reviews) return;

    const count = Math.max(0, Number(reviews.dataset.reviewCount || 0));
    const rating = Math.max(0, Math.min(5, Number(reviews.dataset.reviewRating || 0)));
    const roundedRating = Math.round(rating);
    const formattedRating = (Math.round(rating * 10) / 10).toFixed(1).replace('.', ',');

    $$('[data-product-review-summary]').forEach((summary) => {
      $$('[data-review-summary-stars] > span', summary).forEach((star, index) => {
        star.classList.toggle('is-filled', index < roundedRating);
      });

      const ratingLabel = $('[data-review-summary-rating]', summary);
      const countLink = $('[data-review-summary-count]', summary);
      const emptyLabel = $('[data-review-summary-empty]', summary);

      if (ratingLabel) ratingLabel.textContent = count > 0 ? `${formattedRating} de 5` : 'Sin reseñas todavía';
      if (countLink) {
        countLink.hidden = count < 1;
        countLink.textContent = `${count} ${count === 1 ? 'reseña' : 'reseñas'}`;
      }
      if (emptyLabel) emptyLabel.hidden = count > 0;
    });
  };

  const setCircularCarousel = (carousel, requestedIndex) => {
    const slides = $$('[data-carousel-slide]', carousel);
    if (!slides.length) return;
    const count = slides.length;
    const activeIndex = ((requestedIndex % count) + count) % count;
    const previousIndex = (activeIndex - 1 + count) % count;
    const nextIndex = (activeIndex + 1) % count;

    slides.forEach((slide, index) => {
      slide.classList.remove('is-previous', 'is-active', 'is-next');
      const isActive = index === activeIndex;
      if (isActive) slide.classList.add('is-active');
      if (count > 1 && index === previousIndex) slide.classList.add('is-previous');
      if (count > 2 && index === nextIndex) slide.classList.add('is-next');
      if (count === 2 && index === nextIndex) slide.classList.add('is-next');
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      slide.toggleAttribute('inert', !isActive);

      const video = $('video', slide);
      if (video && !isActive) video.pause();
      if (video && isActive && video.hasAttribute('autoplay')) video.play().catch(() => {});
    });

    carousel.dataset.activeIndex = String(activeIndex);
    const section = carousel.closest('.video-showcase');
    $$('[data-carousel-dot]', section || document).forEach((dot, index) => {
      if (index === activeIndex) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  };

  const rotateCircularCarousel = (carousel, direction) => {
    const current = Number(carousel.dataset.activeIndex || 0);
    setCircularCarousel(carousel, current + (direction === 'next' ? 1 : -1));
  };

  const initCircularCarousels = (root = document) => {
    const carousels = root.matches?.('[data-circular-carousel]') ? [root] : $$('[data-circular-carousel]', root);
    carousels.forEach((carousel) => {
      if (carousel.dataset.carouselInitialized === 'true') return;
      carousel.dataset.carouselInitialized = 'true';
      const slides = $$('[data-carousel-slide]', carousel);
      const initial = Math.floor(slides.length / 2);
      setCircularCarousel(carousel, initial);

      let touchStartX = null;
      carousel.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0]?.clientX ?? null; }, { passive: true });
      carousel.addEventListener('touchend', (event) => {
        if (touchStartX === null) return;
        const distance = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
        if (Math.abs(distance) > 45) rotateCircularCarousel(carousel, distance < 0 ? 'next' : 'previous');
        touchStartX = null;
      }, { passive: true });
    });
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-drawer-open]');
    if (opener) { event.preventDefault(); openDrawer(opener.dataset.drawerOpen); return; }
    const closer = event.target.closest('[data-drawer-close]');
    if (closer) { event.preventDefault(); closeDrawer(closer.closest('.drawer')); return; }
    const menu = event.target.closest('[data-mobile-menu-toggle]');
    if (menu) {
      const panel = document.getElementById(menu.getAttribute('aria-controls'));
      const open = menu.getAttribute('aria-expanded') === 'true';
      menu.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (panel) panel.open = !open;
      return;
    }
    const wishlist = event.target.closest('[data-wishlist-button]');
    if (wishlist && config.settings.wishlist) { event.preventDefault(); toggleWishlist(wishlist); return; }
    const quantityButton = event.target.closest('[data-quantity-change]');
    if (quantityButton) {
      const wrapper = quantityButton.closest('.quantity');
      const input = $('input', wrapper);
      const next = Math.max(Number(input.min || 1), Number(input.value || 1) + Number(quantityButton.dataset.quantityChange));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const cartChange = event.target.closest('[data-cart-change]');
    if (cartChange) {
      event.preventDefault();
      changeCartLine(Number(cartChange.dataset.line), Number(cartChange.dataset.quantity), cartChange);
      return;
    }
    const carousel = event.target.closest('[data-carousel-control]');
    if (carousel) {
      const target = document.getElementById(carousel.getAttribute('aria-controls'));
      if (target?.matches('[data-circular-carousel]')) rotateCircularCarousel(target, carousel.dataset.carouselControl);
      else if (target) target.scrollBy({ left: (carousel.dataset.carouselControl === 'next' ? 1 : -1) * target.clientWidth * .8, behavior: 'smooth' });
      return;
    }
    const carouselDot = event.target.closest('[data-carousel-dot]');
    if (carouselDot) {
      const target = document.getElementById(carouselDot.getAttribute('aria-controls'));
      if (target) setCircularCarousel(target, Number(carouselDot.dataset.carouselDot));
      return;
    }
    const productCard = event.target.closest('[data-product-card]');
    if (productCard && !event.target.closest('a,button,input,select,textarea,form,label')) {
      const url = productCard.dataset.productUrl;
      if (url) window.location.assign(url);
      return;
    }
    const videoPlay = event.target.closest('[data-video-play]');
    if (videoPlay) {
      const video = $('video', videoPlay.closest('.video-card__media'));
      if (video) { videoPlay.hidden = true; video.controls = true; video.play(); }
      return;
    }
    const videoCard = event.target.closest('[data-carousel-slide]');
    if (videoCard) {
      const circularCarousel = videoCard.closest('[data-circular-carousel]');
      if (circularCarousel && !videoCard.classList.contains('is-active')) {
        event.preventDefault();
        setCircularCarousel(circularCarousel, $$('[data-carousel-slide]', circularCarousel).indexOf(videoCard));
        return;
      }
      if (!event.target.closest('a,button') && videoCard.dataset.videoCardUrl) {
        event.preventDefault();
        if (videoCard.dataset.videoCardTarget === '_blank') window.open(videoCard.dataset.videoCardUrl, '_blank', 'noopener');
        else if (videoCard.dataset.videoCardProduct === 'true') window.location.assign(videoCard.dataset.videoCardUrl);
        else navigateWithTransition(videoCard.dataset.videoCardUrl);
      }
    }
  });

  document.addEventListener('submit', (event) => {
    const checkoutForm = event.target.closest('[data-checkout-form]');
    if (checkoutForm && event.submitter?.name === 'checkout' && !validateCheckoutRut(checkoutForm)) {
      event.preventDefault();
      return;
    }
    const form = event.target.closest('[data-product-form]');
    if (form && config.settings.ajaxCart) { event.preventDefault(); submitProduct(form); }
  });

  document.addEventListener('input', (event) => {
    const rut = event.target.closest('[data-rut-input]');
    if (!rut) return;
    rut.setCustomValidity('');
    const error = $('[data-rut-error]', rut.closest('form') || document);
    if (error) error.hidden = true;
  });

  document.addEventListener('focusout', (event) => {
    const rut = event.target.closest('[data-rut-input]');
    if (rut && cleanRut(rut.value).length > 1) rut.value = formatRut(rut.value);
  });

  document.addEventListener('change', (event) => {
    const cartInput = event.target.closest('[data-cart-line-input]');
    if (cartInput && cartInput.closest('#CartDrawer')) changeCartLine(Number(cartInput.dataset.line), Number(cartInput.value), cartInput);
    const sort = event.target.closest('[data-sort-select]');
    if (sort) sort.form.submit();
  });

  document.addEventListener('keydown', (event) => {
    const scrollCarousel = event.target.closest('[data-scroll-carousel]');
    if (scrollCarousel && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
      event.preventDefault();
      scrollCarousel.scrollBy({
        left: (event.key === 'ArrowRight' ? 1 : -1) * scrollCarousel.clientWidth * .8,
        behavior: 'smooth'
      });
      return;
    }
    const carousel = event.target.closest('[data-circular-carousel]');
    if (carousel && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
      event.preventDefault();
      rotateCircularCarousel(carousel, event.key === 'ArrowRight' ? 'next' : 'previous');
      return;
    }
    const drawer = $('.drawer.is-open');
    if (!drawer) return;
    if (event.key === 'Escape') { closeDrawer(drawer); return; }
    if (event.key !== 'Tab') return;
    const items = focusables(drawer);
    if (!items.length) return;
    const first = items[0]; const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  document.addEventListener('DOMContentLoaded', () => {
    syncWishlist();
    initPredictiveSearch();
    initReveal();
    initHeroHandoffs();
    initSectionWaves();
    initProductCardMotion();
    syncProductReviewSummary();
    initWishlistPage();
    initCircularCarousels();
    initFaqAccordions();
  });
  document.addEventListener('shopify:section:load', (event) => {
    initCircularCarousels(event.target);
    initHeroHandoffs();
    initSectionWaves();
    initProductCardMotion(event.target);
    syncProductReviewSummary();
    initReveal();
    initFaqAccordions(event.target);
  });
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest?.('[data-carousel-slide]');
    const carousel = slide?.closest('[data-circular-carousel]');
    if (!slide || !carousel) return;
    setCircularCarousel(carousel, $$('[data-carousel-slide]', carousel).indexOf(slide));
  });
})();
